
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSwiper } from '../hooks/useSwiper';
import ProjectCard from './ProjectCard';

const ProjectSecOne = ({ className }) => {
    const swiperRef = useSwiper();
    const { t } = useTranslation();
  return (

    <section className={className} data-bg-src="assets/img/hero/hero-bg1-1.png">
        <div className="shape-mockup bg-gradient-shape1" data-top={0} data-left={0} />
        <div className="container">
            <div className="row gy-50 align-items-center">
            <div className="col-xl-5">
                <div className="title-area">
                <span className="sub-title" data-cue="slideInUp">{t('sections.projectSecOne.sub_title','Our Portfolio')}</span>
                <h2 className="sec-title" data-cue="slideInUp">{t('sections.projectSecOne.title','A Showcase of Cyber security Excellence')}</h2>
                <p data-cue="slideInUp">{t('sections.projectSecOne.text','Explore our diverse range of cyber security solutions and services. Discover how our innovative approach safeguards digital assets.')}</p>
                </div>
                <div className="btn-wrap" data-cue="slideInUp">
                <Link to="/portfolio" className="ot-btn style-border">{t('sections.projectSecOne.view_more','View More Projects')}<i className="far fa-long-arrow-right ms-2" /></Link>
                </div>
            </div>
            <div className="col-xl-7">
                <div className="slider-area project-slider1">
                    <div
                        ref={swiperRef}
                        className="swiper ot-react-slider"
                        data-cue="slideInUp" data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"2"},"1300":{"slidesPerView":"2.3"},"1400":{"slidesPerView":"2.8"},"1930":{"slidesPerView":"3"}}}'
                    >
                        <div className="swiper-wrapper">
                            <ProjectCard className="swiper-slide" limit={6} />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>

  );
};

export default ProjectSecOne;